export default __webpack_public_path__ + "static/media/Program1_documents_3.cede77dd.jpg";